import { BlogRootEntityTypes } from 'common/enums/blog-root-entity-types'
import ServerPageInterface from 'server/types/ServerPageInterface'

export default function setParentIdSafeCommand(
  page: ServerPageInterface,
): [ServerPageInterface, boolean] {
  let needChangeContent = false
  const originalEntities = page.content.entities
  Object.values(originalEntities).forEach((entity, _, entities) => {
    // since we merge blog layout connect we might set parentId to BlogPageBody, but it leads to issue with breadcrumbs
    if (!entity.parentId && !BlogRootEntityTypes.includes(entity.type)) {
      const parentEntity = entities.find(e => e.childIds?.includes(entity.id))
      if (parentEntity) {
        needChangeContent = true
        originalEntities[entity.id].parentId = parentEntity.id
      }
    }
  })

  return [page, needChangeContent]
}
